angular.module('TurneroApp').component('coUsuariosAlta', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'usuariosService',
        'utilsService',
        'TurneroAppConstant',
        function (usuariosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.usuarioAlta = {};
            ctrl.listaRolesAlta = [];
            ctrl.CidiInfo = {};
            ctrl.CiDiCuil = "";
            ctrl.CiDiencontrado = false;
            ctrl.errores = {
                cuil: false,
                roles: false,
                rolesSU: false
            };

            ctrl.limpiarVariables = function () {
                ctrl.usuarioAlta = {};
                ctrl.listaRolesAlta = [];
                ctrl.CidiInfo = {};
                ctrl.CiDiCuil = "";
                ctrl.CiDiencontrado = false;
                ctrl.errores = {
                    cuil: false,
                    roles: false,
                    rolesSU: false
                };
            }

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.limpiarVariables();

                    usuariosService.getInfo({ 'Id_Centro_Usuario': '' }).$promise.then(function (res) {
                        ctrl.listaRolesAlta = [];
                        ctrl.usuarioAlta = res;
                        ctrl.usuarioAlta.N_Centro_Atencion = ctrl.centroAtencionSeleccionado.text;
                        ctrl.usuarioAlta.Id_Centro_Atencion = ctrl.centroAtencionSeleccionado.id;
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                }
            }

            ctrl.$onChanges = function () {
                
            }

            ctrl.guardarUsuarioNuevo = function () {
                ctrl.errores.buscarcuil = ctrl.CiDiCuil ? (ctrl.CidiInfo.Return && ctrl.CidiInfo.Return.Cuil ? false : true) : false;
                ctrl.errores.cuil = ctrl.CidiInfo.Return && ctrl.CidiInfo.Return.Cuil ? false : true;
                ctrl.errores.roles = !ctrl.usuarioAlta.Id_Rol_Alta

                if (ctrl.errores.cuil || ctrl.errores.roles || ctrl.errores.rolesSU || ctrl.errores.buscarcuil) {
                    return;
                }

                ctrl.usuarioAlta.N_Usuario = ctrl.CidiInfo.Return.Cuil;
                if (ctrl.usuarioAlta.Id_Rol_Alta.length > 0) {
                    usuariosService.save(ctrl.usuarioAlta).$promise.then(function (res) {
                        ctrl.ctrlPadre.grillaReload();
                        ctrl.limpiarVariables();
                        sweetAlert("Alta Usuario", "El usuario se registró correctamente", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                } else {
                    sweetAlert("Usuario sin rol asignado.", "Debe seleccionar al menos un rol para este usuario", "warning");
                };
            };

            ctrl.cambiosEnRoles = function (item) {
                if (item) {
                    ctrl.errores.roles = false;
                }

                if (ctrl.ctrlPadre.validarSiTieneSU(item)) {
                    ctrl.errores.rolesSU = false;
                    ctrl.usuarioAlta.Id_Rol_Alta = '';
                    if (item.length != 0) {
                        for (var i = 0; i < item.length; i++) {
                            ctrl.usuarioAlta.Id_Rol_Alta = ctrl.usuarioAlta.Id_Rol_Alta.length > 0 ? ctrl.usuarioAlta.Id_Rol_Alta + ',' + item[i].Id_Rol.toString() : item[i].Id_Rol.toString();
                        }
                    }
                }
                else {
                    ctrl.errores.rolesSU = true;
                }
            };

            ctrl.getCidi = function (N_Usuario) {
                if (!N_Usuario) {
                    ctrl.errores.cuil = true;
                    return;
                }
                usuariosService.getCiDiInfo({ 'CUIL': N_Usuario }).$promise.then(function (res) {
                    ctrl.CiDiencontrado = false;
                    ctrl.CidiInfo = res;
                    if (res.Return.NombreYApellido != null)
                        ctrl.CiDiencontrado = true;
                }).catch(function (req) {
                    var msj = "";
                    var errors = req.data.ExceptionMessage ? req.data.ExceptionMessage.split(",") : (req.data.Message ? req.data.Message.split(",") : req.data.split(","));

                    if (errors.length > 0) {
                        ctrl.CiDiencontrado = false;
                        ctrl.CidiInfo = {};
                        ctrl.CiDiCuil = "";

                        if (errors[0] = "USU_NOT") {
                            msj = "No se encontró el CUIL en Ciudadano Digital";
                        }
                        else {
                            msj = req.data.ExceptionMessage ? req.data.ExceptionMessage : (req.data.Message ? req.data.Message : req.data);
                        }
                    }

                    sweetAlert("Oops...", "Algo ocurrió y no se pudo completar la acción. </br>" + msj, "warning");
                });
            };

            ctrl.quitarCidi = function () {
                ctrl.CiDiencontrado = false;
                ctrl.CidiInfo = {};
                ctrl.CiDiCuil = "";
            }

            ctrl.cancelar = function () {
                ctrl.limpiarVariables();
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./usuariosAlta.html')
});


// WEBPACK FOOTER //
// ./app/components/usuarios/usuariosAltaComponent.js